import { getIssuePriority } from 'shared/constants/issues';
import {
  IssueTitleColumn,
  EmergencyColumn,
  OrderTimeColumn,
  CompleteTimeColumn,
  PriceColumn,
  ViewColumn,
  FlagColumn,
} from 'views/Billing/commonColumns';
import logger from 'utils/logger';

const log = logger.createLogger('DetailsTable');

export const getDetailedTableData = (
  billData,
  selectedDstOrgId,
  selectedBillingMonth
) => {
  const monthlyBills = billData.find(
    (bill) =>
      bill.orgId === selectedDstOrgId &&
      bill.billedMonthYear === selectedBillingMonth
  );
  if (!monthlyBills) return [];
  const monthlyBillsData = monthlyBills.bills;

  monthlyBillsData.sort((a, b) => a.createdAt - b.createdAt);

  const tableData = monthlyBillsData.map((bill) => {
    const {
      id,
      issueCreatedAt,
      createdAt,
      issueId,
      issueTitle,
      issuePriority,
      originalFee,
      currentFee,
      starred,
    } = bill;

    return {
      issueTitle: issueTitle,
      emergency: getIssuePriority(issuePriority),
      orderTime: issueCreatedAt,
      completeTime: createdAt,
      price: {
        originalFee: originalFee,
        currentFee: currentFee,
      },
      view: {
        billId: id,
        issueId: issueId,
      },
      flag: starred,
    };
  });
  return tableData;
};

export const detailsTableColumns = (openIssue) => [
  IssueTitleColumn(),
  EmergencyColumn(),
  OrderTimeColumn(),
  CompleteTimeColumn(),
  PriceColumn(),
  ViewColumn(openIssue),
  FlagColumn(),
];
